<template>
  <div>
    <b-form-row>
      <b-col>
        <b-form-group label="Adresse courriel">
          <b-form-input
            v-model="email"
            type="email"
            :state="validateState('email')"
            aria-describedby="input-email-feedback"
            @input="setField('email', $event)"
            @keyup.enter="validateBeforeSubmit"
          />
          <b-form-invalid-feedback id="input-email-feedback">
            Veuillez entrer une adresse courriel valide
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group label="Mot de passe">
          <b-form-input
            v-model="password"
            :disable-strength="true"
            class="form-control"
            type="password"
            :state="validateState('password')"
            aria-describedby="input-password-feedback"
            @input="setField('password', $event)"
            @keyup.enter="validateBeforeSubmit"
            ref="password"
          />
          <password-toggle :input="$refs['password']" />
          <b-form-invalid-feedback id="input-password-feedback">
            <template
              v-if="!$v.password.required || !$v.password.minLength"
            >
              Votre mot de passe doit contenir un minimum de 6 caractères.
            </template>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-form-row>

    <div class="form-group">
      <slot name="errors"></slot>
    </div>
    <br />

    <div class="form-group">
      <b-button
        :disabled="status.loggingIn"
        style="margin-top: 15px; width: 100%"
        variant="primary"
        @click="validateBeforeSubmit"
      >
        Connexion
      </b-button>
    </div>
  </div>
</template>

<script>
  import PasswordToggle from '@/components/inputs/password-toggle';
  import { mapState } from 'vuex';
  const { required, minLength, email } = require('vuelidate/lib/validators');

  export default {
    name: 'LoginForm',
    components: { PasswordToggle },
    data() {
      return {
        email: '',
        password: ''
      };
    },
    computed: {
      ...mapState('account', [ 'status' ])
    },
    validations: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(6)
      }
    },
    methods: {
      validateBeforeSubmit() {
        if (this.check() === true) {
          this.$emit('LoginFormValid', {
            email: this.email,
            password: this.password
          });
        }
      },
      validateState(name) {
        const { $dirty, $error } = this.$v[name];
        return $dirty ? !$error : null;
      },
      setField(field, street) {
        this[field] = street;
        this.$v[field].$touch();
      },
      check() {
        this.$v.$touch();
        return !this.$v.$anyError;
      }
    }
  };
</script>

<style scoped>
.error {
  color: #dc3545;
}
fieldset {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
